import ApiMethods from '../ApiMethods'
import ENDPOINTS from '../Endpoints'
import { Buffer } from 'buffer'

class DrupalApiManager {
    static uploadFile = async (data, entityId, contentType, fieldName, isBase64 = false) => {
        const userData = JSON.parse(localStorage.getItem('userData'))
        let token = userData?.tokenResponse?.access_token || null

        let bufferData = null
        if(isBase64){
            const base64Data = data.split(',')[1]
            bufferData = Buffer.from(base64Data, 'base64')
        } else{
            bufferData = Buffer.from(await data.arrayBuffer(), 'binary')
        }
        const randomName = Math.random().toString(36).substring(2, 15) + '.jpg'
        const fileResult = await ApiMethods.postFile(
            ENDPOINTS.UPLOAD_FILE(entityId, contentType, fieldName),
            bufferData,
            {
                'Content-Type': 'application/octet-stream',
                Accept: 'application/vnd.api+json',
                'Content-Disposition': `file; filename="${data.name || randomName}"`,
                Authorization: `Bearer ${token}`,
                'User-Agent': 'oktv-panel-KwhjAsSJAV',
                'X-Oktv-User-Agent': 'oktv-panel-KwhjAsSJAV',
            }
        )

        return fileResult.data.fid[0].value
    }

    static b64toBlob(b64Data, contentType='', sliceSize=512) {
        const byteCharacters = atob(b64Data);
        const byteArrays = [];
      
        for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
          const slice = byteCharacters.slice(offset, offset + sliceSize);
      
          const byteNumbers = new Array(slice.length);
          for (let i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
          }
      
          const byteArray = new Uint8Array(byteNumbers);
          byteArrays.push(byteArray);
        }
          
        const blob = new Blob(byteArrays, {type: contentType});
        return blob;
      }
}

export default DrupalApiManager
